import { css } from '@emotion/react'
import { Stack, Text } from 'fitify-ui-onboarding/src/components'
import { motion } from 'framer-motion'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'

export function CoachLoading({ onComplete }: { onComplete: () => void }) {
  const { t } = useTranslation()
  const [done, setDone] = useState(false)
  const [progress, setProgress] = useState(0)

  function onUpdate(latest: { pathLength: number }) {
    const value = Math.round(latest.pathLength * 100)
    if (value !== progress) {
      setProgress(value)
      if (value === 100)
        setTimeout(() => {
          setDone(true)
          setTimeout(() => onComplete(), 500)
        }, 300)
    }
  }

  return (
    <Stack css={{ alignItems: 'center' }}>
      <div css={{ position: 'relative' }}>
        {!done && (
          <Text
            size="lg"
            css={css`
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);

              font-family: 'Graphik Wide Web';
            `}
          >
            {progress}%
          </Text>
        )}

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="154"
          height="154"
          fill="none"
          viewBox="0 0 154 154"
        >
          <path
            d="M77,7c-9.2,0-18.3,1.8-26.8,5.3C41.7,15.8,34,21,27.5,27.5C21,34,15.8,41.7,12.3,50.2C8.8,58.7,7,67.8,7,77
	s1.8,18.3,5.3,26.8c3.5,8.5,8.7,16.2,15.2,22.7c6.5,6.5,14.2,11.7,22.7,15.2c8.5,3.5,17.6,5.3,26.8,5.3c9.2,0,18.3-1.8,26.8-5.3
	c8.5-3.5,16.2-8.7,22.7-15.2c6.5-6.5,11.7-14.2,15.2-22.7S147,86.2,147,77c0-9.2-1.8-18.3-5.3-26.8c-3.5-8.5-8.7-16.2-15.2-22.7
	c-6.5-6.5-14.2-11.7-22.7-15.2C95.3,8.8,86.2,7,77,7L77,7z"
            stroke="var(--c-gray200)"
            strokeLinecap="round"
            strokeWidth="12"
          />

          {done && (
            <path
              d="M46.6045 77.6293L66.0768 97.6201L106.074 56.5579"
              stroke="var(--c-blue400)"
              strokeWidth="12.7435"
              strokeLinecap="round"
            />
          )}

          <motion.path
            d="M77,7c-9.2,0-18.3,1.8-26.8,5.3C41.7,15.8,34,21,27.5,27.5C21,34,15.8,41.7,12.3,50.2C8.8,58.7,7,67.8,7,77
	s1.8,18.3,5.3,26.8c3.5,8.5,8.7,16.2,15.2,22.7c6.5,6.5,14.2,11.7,22.7,15.2c8.5,3.5,17.6,5.3,26.8,5.3c9.2,0,18.3-1.8,26.8-5.3
	c8.5-3.5,16.2-8.7,22.7-15.2c6.5-6.5,11.7-14.2,15.2-22.7S147,86.2,147,77c0-9.2-1.8-18.3-5.3-26.8c-3.5-8.5-8.7-16.2-15.2-22.7
	c-6.5-6.5-14.2-11.7-22.7-15.2C95.3,8.8,86.2,7,77,7L77,7z"
            stroke="var(--c-blue400)"
            strokeLinecap="round"
            strokeWidth="12.7435"
            initial={{ pathLength: 0, pathOffset: 1 }}
            animate={{ pathLength: 1, pathOffset: 0 }}
            transition={{ duration: 4 }}
            onUpdate={onUpdate}
          />
        </svg>
      </div>

      <Text size="md" style={{ height: '76px', paddingTop: '2rem' }}>
        {!done ? t('hc_onboarding_generator_progress_description') : ''}
      </Text>
    </Stack>
  )
}
